import { createSlice } from '@reduxjs/toolkit';
import { TaskBoardState } from './taskBoardTypes';
import { 
  createTaskBoard, 
  fetchTaskBoards, 
  fetchTaskBoardById, 
  updateTaskBoard, 
  deleteTaskBoard 
} from './taskBoardActions';

const initialState: TaskBoardState = {
  taskBoards: [],
  selectedTaskBoard: undefined,
  loading: false,
  error: undefined,
};

const taskBoardSlice = createSlice({
  name: 'taskBoard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Task Board
      .addCase(createTaskBoard.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createTaskBoard.fulfilled, (state, action) => {
        state.loading = false;
        state.taskBoards.push(action.payload);
      })
      .addCase(createTaskBoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Task Boards
      .addCase(fetchTaskBoards.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTaskBoards.fulfilled, (state, action) => {
        state.loading = false;
        state.taskBoards = action.payload.data;
      })
      .addCase(fetchTaskBoards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Task Board by ID
      .addCase(fetchTaskBoardById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTaskBoardById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTaskBoard = action.payload;
      })
      .addCase(fetchTaskBoardById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Task Board
      .addCase(updateTaskBoard.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateTaskBoard.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.taskBoards.findIndex(board => board.id === action.payload.id);
        if (index !== -1) {
          state.taskBoards[index] = action.payload;
        }
      })
      .addCase(updateTaskBoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Task Board
      .addCase(deleteTaskBoard.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteTaskBoard.fulfilled, (state, action) => {
        state.loading = false;
        state.taskBoards = state.taskBoards.filter(board => board.id !== action.payload.id);
      })
      .addCase(deleteTaskBoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default taskBoardSlice.reducer;
